{
  "next": "Nästa",
  "nextStep": "Nästa: {step}",
  "back": "Tillbaka",
  "backToStart": "Tillbaka till startsidan",
  "submit": "Skicka",
  "submitContinue": "Gå vidare",
  "submitNextStepNote": "Registrerar din medlemsansökan. I nästa steg väljer du hur du vill aktivera autogiro.",
  "donationTypeMonthly": "Varje månad",
  "donationTypeSingle": "En gång",
  "amountLabel": "Belopp",
  "customAmount": "Eget belopp",
  "minAmount": "Minsta belopp är {min} {currency}",
  "perMonth": "{amount} kr/mån",
  "firstName": "Förnamn",
  "lastName": "Efternamn",
  "email": "E-post",
  "mobile": "Mobilnummer",
  "ssn": "Personnummer",
  "ssnPlaceholder": "ÅÅÅÅMMDD-NNNN",
  "ssnHint": "Till exempel 19940906-2388, används för att registrera din gåva och försöka hämta din postadress.",
  "membershipSsnHint": "Till exempel 19940906-2388, används för att registrera ditt medlemskap och försöka hämta din postadress.",
  "ssnMissingHelp": "Saknar du eller vill du inte uppge personnummer? Kontakta givarservice så hjälper vi dig:",
  "birthDate": "Födelsedatum",
  "birthDateHint": "Ett födelsedatum, ÅÅÅÅ-MM-DD",
  "ssnOrBirthdateHint": "Har du inget svenskt personnummer? Fyll i ditt födelsedatum istället.",
  "birthDatePlaceholder": "ÅÅÅÅ-MM-DD",
  "selectCountry": "Välj land",
  "street": "Gatuadress",
  "postcode": "Postnummer",
  "city": "Ort",
  "country": "Land",
  "consentHeader": "Signera autogiromedgivande",
  "consentSubtitle": "Signera med BankID eller få medgivandet per post",
  "consentBankid": "Signera med BankID",
  "consentPostal": "Få medgivande per post",
  "bankidStarting": "Startar BankID …",
  "bankidPending": "Öppna BankID-appen och signera",
  "bankidPendingIdentify": "Öppna BankID-appen och identifiera dig",
  "bankidComplete": "Signering klar",
  "bankidFailed": "Signeringen avbröts",
  "bankidRetry": "Försök igen",
  "openBankid": "Öppna BankID",
  "errorGeneric": "Något gick fel. Försök igen.",
  "formClosed": "Insamlingen är stängd.",
  "formTryAgain": "Något gick tillfälligt fel. Försök igen om en stund.",
  "errorModalTitle": "Ojdå, något gick fel!",
  "errorModalRetry": "Försök igen",
  "errorModalContact": "Kontakta gärna givarservice:",
  "alreadyMemberTitle": "Redan medlem",
  "required": "Fältet är obligatoriskt",
  "invalidEmail": "Ogiltig e-postadress",
  "invalidClearing": "Clearingnumret ska vara 4 siffror",
  "invalidAccount": "Kontonumret ska vara 4–12 siffror",
  "invalidSsn": "Ogiltigt personnummer",
  "invalidMobile": "Ogiltigt mobilnummer",
  "invalidPostcode": "Ogiltigt postnummer",
  "minorDisclaimer": "För att bli månadsgivare hos Djurens Rätt måste du vara minst 18 år gammal. Du kan istället välja att ",
  "minorLinkYouth": "bli årsmedlem.",
  "minorLinkChild": "gå med i Rädda Djuren-klubben.",
  "giftTitle": "Vilken välkomstpresent vill du ha?",
  "giftSubtitle": "Presenten skickas till dig via post",
  "skipGift": "Jag önskar ingen present",
  "enlargeGiftImage": "Visa större bild: {title}",
  "chooseThisGift": "Välj presenten",
  "bankidSignMessage": "Jag godkänner en gåva på {amount} SEK till Djurens Rätt varje månad som betalas via autogiro. Detta kan när som helst avbrytas genom att kontakta Djurens Rätt.",
  "bankidSignMessageNoAmount": "Jag godkänner ett autogiromedgivande till Djurens Rätt. Detta kan när som helst avbrytas genom att kontakta Djurens Rätt.",
  "thankYouTitle": "Tack för ditt stöd!",
  "thankYouTitleCompany": "Tack för ert stöd!",
  "lookupCta": "Hämta mina uppgifter",
  "lookupPending": "Hämtar …",
  "lookupNotFound": "Inga uppgifter hittades — fyll i manuellt",
  "consentLinkNotFound": "Vi hittade inget medgivande att signera för den här länken. Kontrollera att du använt hela länken från vårt utskick, eller kontakta oss så hjälper vi dig.",
  "lookupConfirm": "Vi hittade dina uppgifter:",
  "lookupManual": "Fyll i själv",
  "lookupInstead": "Hämta uppgifter istället",
  "enterManually": "Fyll i kontonummer manuellt",
  "manualFallbackPrompt": "Vill du istället",
  "manualFallbackLink": "fylla i kontouppgifterna manuellt",
  "accountFetchPrompt": "Hur vill du ange ditt kontonummer?",
  "useAccountConfirm": "Använd detta konto",
  "bank": "Bank",
  "bankSelect": "Välj bank",
  "bankOther": "Annan bank",
  "fetchAccounts": "Hämta konto via din bank",
  "fetchingAccounts": "Hämtar konto …",
  "accountsFailed": "Kunde inte hämta konto",
  "clearing": "Clearingnummer",
  "account": "Kontonummer",
  "changeAccountPrefix": "Fel konto? Du kan",
  "changeAccountManual": "fylla i det manuellt",
  "changeAccountOr": "eller",
  "changeAccountFetch": "hämta ett annat konto",
  "clearingHint": "Normalt 4 siffror. Sparbankerna/Swedbank har 5 (NNNN-N) – fyll i utan bindestreck.",
  "sparbankWarning": "Det är viktigt att du väljer rätt alternativ av Sparbanken Syd, Swedbank eller Swedbank Sparbankerna. Om ett alternativ inte fungerar, testa med en annan.",
  "flowTitle": "Bli månadsgivare",
  "progressLabel": "Förlopp",
  "stepOf": "Steg {step} av {total}",
  "stepAmount": "Belopp",
  "stepGift": "Present",
  "stepDetails": "Uppgifter",
  "stepAddress": "Adress",
  "stepConsent": "Medgivande",
  "stepPayment": "Betalning",
  "thankYouBody": "Du är nu månadsgivare. Tillsammans gör vi skillnad för djuren.",
  "thankYouBodyCompany": "Ni är nu månadsgivare. Tillsammans gör vi skillnad för djuren.",
  "donate": "Ge en gåva",
  "donationFlowTitle": "Ge en gåva",
  "choosePayment": "Hur vill du betala?",
  "choosePaymentCompany": "Hur vill ni betala?",
  "paySwish": "Swish",
  "paySwishDesc": "Betala direkt med Swish",
  "payCard": "Kort",
  "payCardDesc": "Betala med kort",
  "payPostal": "Faktura",
  "payPostalDesc": "Få en faktura per post",
  "redirecting": "Skickar dig vidare till betalningen …",
  "redirectingCompany": "Skickar er vidare till betalningen …",
  "donationCancelled": "Betalningen avbröts. Du kan försöka igen.",
  "donationThankYouTitle": "Tack för din gåva!",
  "donationThankYouTitleCompany": "Tack för er gåva!",
  "donationThankYouBody": "Din gåva gör skillnad för djuren.",
  "donationPostalBody": "Din faktura skickas till dig per post. Tack för din gåva!",
  "integrityText": "För att kunna hantera ditt medlemskap och informera dig om arbetet för djuren sparar vi uppgifterna du lämnar. Det görs enligt dataskyddsförordningen vilket innebär att vi garanterar att dina uppgifter skyddas och inte lämnas ut till någon annan.",
  "integrityTextDonation": "För att kunna hantera din gåva och informera dig om arbetet för djuren sparar vi uppgifterna du lämnar. Det görs enligt dataskyddsförordningen vilket innebär att vi garanterar att dina uppgifter skyddas och inte lämnas ut till någon annan.",
  "integrityTextDonationCompany": "För att kunna hantera er gåva och informera er om arbetet för djuren sparar vi uppgifterna ni lämnar. Det görs enligt dataskyddsförordningen vilket innebär att vi garanterar att era uppgifter skyddas och inte lämnas ut till någon annan.",
  "integrityTextPetition": "För att registrera din underskrift och informera dig om arbetet för djuren sparar vi uppgifterna du lämnar. Namn och ev. motivering blir den underskrift vi lämnar över i kampanjen. Vi hanterar uppgifterna enligt dataskyddsförordningen vilket garanterar att dina uppgifter skyddas och inte lämnas ut på något annat sätt.",
  "integrityTextActivist": "För att kunna registrera dig som digital volontär och informera dig om vårt arbete för djuren sparar vi de uppgifter du lämnar. Det gör vi enligt dataskyddsförordningen vilket innebär att vi garanterar att dina uppgifter skyddas och inte lämnas ut till någon annan.",
  "integrityMore": "Läs mer i vår integritetspolicy",
  "integrityMoreLink": "integritetspolicy",
  "integrityUrl": "https://djurensratt.se/integritet",
  "annualFlowTitle": "Bli årsmedlem",
  "stepCategory": "Medlemskap",
  "chooseCategory": "Vilket medlemskap vill du ha?",
  "categoryOrdinary": "Ordinarie medlemsavgift: 330 kr",
  "categoryOrdinaryDesc": "Största stödet för djuren❤️ Var med och gör större skillnad för djuren.",
  "categoryReduced": "Reducerad medlemsavgift: 150 kr",
  "categoryReducedDesc": "För dig som är 18-25 år, är pensionär eller har sjukersättning.",
  "categoryYouth": "Fri medlemsavgift: 0 kr",
  "categoryYouthDesc": "För dig som är 14-17 år och vill engagera dig för djuren.",
  "membershipTabDjurensRatt": "Djurens Rätt",
  "membershipTabChild": "För barn",
  "membershipDjurensRattTitle": "Medlemskap i Djurens Rätt",
  "membershipDjurensRattSubtitle": "Det ingår 4 medlemstidningar per år. Medlemskapet förnyas årligen.",
  "membershipChildTitle": "Medlemskap i Rädda Djuren-klubben",
  "membershipChildSubtitle": "Ett års medlemskap i Rädda Djuren-klubben är den perfekta presenten till barnet som bryr sig om djur. I medlemskapet ingår 5 medlemstidningar per år och en fin present som du kan ge till den nya medlemmen.",
  "membershipChildNote": "Klicka på knappen nedan för att komma vidare till Rädda Djuren-klubbens hemsida.",
  "youthBirthdateHint": "Fyll i personnummer eller födelsedatum så att vi kan bekräfta att du är 14–17 år.",
  "youthAgeError": "Ungdomsmedlemskap gäller dig som är 14–17 år. Välj ett annat medlemskap.",
  "youthFreeNote": "Ungdomsmedlemskap är kostnadsfritt – du behöver inte betala något.",
  "becomeMember": "Bli medlem",
  "annualThankYouTitle": "Välkommen som medlem!",
  "annualThankYouBody": "Tack för att du blir årsmedlem. Tillsammans gör vi skillnad för djuren.",
  "annualPostalBody": "Din faktura skickas till dig per post. Välkommen som medlem!",
  "annualYouthBody": "Ditt ungdomsmedlemskap är nu registrerat. Välkommen!",
  "alreadyMember": "Du är redan medlem. Hör av dig till givarservice om du har frågor om ditt medlemskap.",
  "notYouFillIn": "Inte du? Fyll i dina egna uppgifter",
  "giftedFlowTitle": "Ge bort en gåva",
  "stepGiftImage": "Motiv",
  "stepGiftDetails": "Hälsning",
  "stepDelivery": "Leverans",
  "giftcertTitle": "Mottagarens namn",
  "giftcertChooseTitle": "Vilket kort vill du skicka?",
  "giftcertChooseSubtitle": "Välj motiv",
  "giftcertTitlePlaceholder": "Till vem är gåvan?",
  "giftcertMessage": "Din hälsning",
  "giftcertMessageHint": "Skriv en personlig hälsning som trycks på gåvobeviset. Glöm inte att skriva vem som är avsändare. Använd inte emoji.",
  "giftcertCharsLeft": "{count} tecken kvar",
  "giftcertMessageNoEmoji": "Hälsningen får inte innehålla emoji.",
  "giftcertMessageTooLong": "Hälsningen får vara högst {max} tecken.",
  "memorialHonoreeName": "Namnet på den du vill hedra",
  "memorialHonoreeNameError": "Du behöver fylla i namnet på den du vill hedra",
  "deliveryTitle": "Hur vill du leverera gåvobeviset?",
  "deliveryDigital": "Digitalt",
  "deliveryPrinted": "Tryckt",
  "deliveryDigitalText": "Gåvobeviset skickas som pdf till din e-post direkt efter att du betalat.",
  "deliveryEmail": "Din e-postadress",
  "deliveryPrintedText": "Vi trycker och postar gåvobeviset.",
  "deliveryRecipientHeading": "Vem ska få gåvobeviset?",
  "deliveryMailToMe": "Skicka gåvobeviset till mig istället",
  "deliverySendWhen": "När ska kortet skickas?",
  "deliverySendNow": "Så snart som möjligt",
  "deliverySendDate": "Välj utskicksdatum",
  "deliverySendDateLabel": "Leveransdatum",
  "deliveryDateInvalid": "Välj ett datum från och med idag",
  "deliveryEstimate": "Beräknad leverans är mellan {range}.",
  "deliveryToMeTitle": "Post till dig",
  "deliveryToMeText": "Gåvobeviset skickas på post till dig och förväntas vara framme inom fem arbetsdagar.",
  "deliveryToRecipientTitle": "Post till mottagaren",
  "deliveryToRecipientText": "Gåvobeviset skickas på post till mottagaren och förväntas vara framme inom fem arbetsdagar från valt utskicksdatum.",
  "deliveryOr": "eller",
  "deliveryNote": "Observera att leverans tar upp till 3–5 vardagar. Leverans kan påverkas av postens utdelning och speciella helgdagar.",
  "deliveryLastDateInfo": "För garanterad leverans innan {message}, beställ senast {date}.",
  "deliveryAfterLastDate": "Vi kan inte längre garantera leverans till {message}.",
  "deliverySwitchDigital": "Välj digital leverans istället – gåvobeviset skickas till din e-post direkt efter betalning.",
  "giftcertThankYouTitle": "Tack för din gåva!",
  "giftcertThankYouBody": "Ditt gåvobevis är på väg. Tack för att du ger bort en gåva till djuren.",
  "giftcertPostalBody": "Din faktura skickas till dig per post. Tack för din gåva!",
  "companyName": "Företagsnamn",
  "organisationNumber": "Organisationsnummer",
  "invoiceEmail": "E-post för faktura",
  "stepCompany": "Företag",
  "perMonthSuffix": "/mån",
  "payInvoice": "Faktura",
  "payInvoiceDesc": "Få en faktura per e-post",
  "companyDonationFlowTitle": "Ge en företagsgåva",
  "recurringFlowTitle": "Bli månadsgivare",
  "companyRecurringFlowTitle": "Bli månadsgivare som företag",
  "recurringThankYouTitle": "Tack för ditt månadsstöd!",
  "recurringThankYouTitleCompany": "Tack för ert månadsstöd!",
  "invoiceThankYouBody": "Din faktura är på väg. Tack för ditt stöd för djuren!",
  "invoiceThankYouBodyCompany": "Er faktura är på väg. Tack för ert stöd för djuren!",
  "giftedMembershipFlowTitle": "Ge bort ett medlemskap i Rädda Djuren-klubben",
  "stepChild": "Mottagare",
  "childDetailsTitle": "Vem ska bli medlem?",
  "childFirstName": "Barnets förnamn",
  "childLastName": "Barnets efternamn",
  "childBirthDate": "Barnets födelsedatum",
  "childBirthDateHint": "Barnet måste vara 13 år eller yngre",
  "childMustBeChild": "Barnet måste vara 13 år eller yngre för att gå med i klubben.",
  "sameAddressAsMe": "Barnet bor på samma adress som jag",
  "agentMustBeAdult": "Du måste vara minst 18 år för att ge bort ett medlemskap.",
  "becomeChildMember": "Ge medlemskap",
  "giftedMembershipThankYouTitle": "Tack för din gåva!",
  "giftedMembershipThankYouBody": "Medlemskapet i Rädda Djuren-klubben är på väg. Tack för att du ger barnet en chans att hjälpa djuren.",
  "giftedMembershipPostalBody": "Din faktura skickas till dig per post. Tack för att du ger bort ett medlemskap!",
  "giftedAnnualStepRecipient": "Mottagare",
  "giftedAnnualStepGiftCard": "Gåvobevis",
  "giftedAnnualRecipientTitle": "Vem ska få medlemskapet?",
  "giftedAnnualRecipientSsn": "Mottagarens personnummer",
  "giftedAnnualRecipientLookupConfirm": "Vi hittade mottagarens uppgifter:",
  "giftedAnnualRecipientSsnHint": "Till exempel 19940906-2388, används för att registrera medlemskapet på rätt person och försöka hämta mottagarens postadress.",
  "giftedAnnualRecipientFirstName": "Mottagarens förnamn",
  "giftedAnnualRecipientLastName": "Mottagarens efternamn",
  "giftedAnnualRecipientBirthDate": "Mottagarens födelsedatum",
  "giftedAnnualSameAddress": "Mottagaren bor på samma adress som jag",
  "giftedAnnualCategoryTitle": "Vilket medlemskap ska mottagaren få?",
  "giftedAnnualPresentTitle": "Vilken välkomstpresent vill du ge?",
  "giftedAnnualGiftCardTitle": "Vilket gåvobevis vill du ge?",
  "giftedAnnualGiftCardSubtitle": "Gåvobeviset skickas till dig per post.",
  "giftedAnnualBuyerTitle": "Vem är du som ger bort medlemskapet?",
  "giftedAnnualSubmit": "Ge bort medlemskapet",
  "giftedAnnualThankYouTitle": "Tack för att du ger bort ett medlemskap!",
  "giftedAnnualThankYouBody": "Tillsammans gör vi skillnad för djuren.",
  "giftedAnnualPostalBody": "Fakturan skickas till dig per post.",
  "giftedAnnualYouthBody": "Ungdomsmedlemskapet är registrerat.",
  "giftedAnnualAlreadyMember": "Mottagaren är redan medlem i Djurens Rätt. Hör av dig till givarservice om du har frågor.",
  "raiseAmountTitle": "Höj ditt månadsbelopp",
  "raiseAmountIntro": "Som månadsgivare hos Djurens Rätt kan du enkelt höja ditt månadsbelopp.",
  "raiseAmountIdentifyTitle": "Identifiera dig",
  "raiseAmountIdentifyIntro": "Logga in med BankID så hämtar vi ditt medlemskap.",
  "raiseAmountIdentifyCta": "Identifiera med BankID",
  "raiseAmountChooseTitle": "Välj ett nytt månadsbelopp",
  "raiseAmountCurrent": "Ditt nuvarande belopp: {amount} kr/mån",
  "raiseAmountSameError": "Du har angett samma belopp som tidigare. Välj ett annat belopp.",
  "raiseAmountMustBeHigher": "Du ger redan {current} {currency}/mån. Välj ett högre belopp för att höja.",
  "raiseAmountMustBeHigherUnknown": "Det nya beloppet måste vara högre än ditt nuvarande.",
  "raiseAmountUnavailable": "Vi kunde inte bekräfta om ändringen gick igenom. Försök igen om en stund – att skicka samma belopp en gång till ändrar inget om det redan är höjt.",
  "raiseAmountNotFound": "Vi kunde inte hitta ditt medlemskap. Kontrollera dina uppgifter och försök igen.",
  "raiseAmountSubmit": "Bekräfta nytt belopp",
  "raiseAmountSuccessTitle": "Månadsgåvan har ändrats",
  "raiseAmountSuccessBody": "Din nya månadsgåva är {amount} kr/mån. Tack för ditt stöd!",
  "raiseAmountAltToggle": "Identifiera dig på annat sätt",
  "raiseAmountHelp": "Kommer du inte vidare? Mejla",
  "raiseAmountAltMemberNumberHint": "Medlemsnumret står i brev från oss och på baksidan av tidningen Djurens Rätt.",
  "raiseAmountAltMobileHint": "Numret du har registrerat hos oss, t.ex. +46xxxxxxxxx.",
  "raiseAmountAltCodeHint": "Den sexsiffriga koden i sms:et.",
  "raiseAmountAltEmailHint": "Adressen du har registrerat hos oss.",
  "raiseAmountAltSsnHint": "Till exempel 19940906-2388, används för att bekräfta att det är du.",
  "raiseAmountAltInvalidCode": "Koden är sex siffror.",
  "raiseAmountAltTabSms": "Sms-kod",
  "raiseAmountAltTabEmail": "Mejllänk",
  "raiseAmountAltTabMember": "Medlemsnummer",
  "raiseAmountAltMobileLabel": "Mobilnummer",
  "raiseAmountAltSmsCta": "Skicka kod",
  "raiseAmountAltSmsSent": "Om numret {mobile} finns hos oss har vi skickat en kod till det. Koden gäller i 10 minuter.",
  "raiseAmountAltCodeLabel": "Kod",
  "raiseAmountAltCodeCta": "Logga in",
  "raiseAmountAltWrongCode": "Koden stämmer inte. Kontrollera den och försök igen.",
  "raiseAmountAltCodeExpired": "Koden har gått ut. Be om en ny.",
  "raiseAmountAltEmailLabel": "E-postadress",
  "raiseAmountAltEmailCta": "Skicka länk",
  "raiseAmountAltEmailSent": "Om adressen {email} finns hos oss har vi skickat en länk till den. Länken gäller i 30 minuter.",
  "raiseAmountAltLinkExpired": "Länken har gått ut. Logga in igen här nedanför.",
  "raiseAmountSignedInAs": "Inloggad som {name}",
  "raiseAmountNotYou": "Inte du?",
  "raiseAmountAltMemberNumberLabel": "Medlemsnummer",
  "raiseAmountAltSsnLabel": "Personnummer",
  "raiseAmountAltMemberCta": "Logga in",
  "raiseAmountAltMemberNoMatch": "Medlemsnumret och personnumret hör inte ihop. Kontrollera dem och försök igen.",
  "raiseAmountAltRateLimited": "Du har försökt för många gånger. Vänta en stund och försök igen.",
  "raiseAmountAltChangeMobile": "Byt nummer",
  "raiseAmountAltUnavailable": "Det gick inte att logga in just nu. Försök igen om en stund.",
  "recommended": "Rekommenderat",
  "surveyBack": "Tillbaka",
  "surveyBlixtCta": "Prenumerera på Blixtmail",
  "surveyBlixtSendsTo": "Blixtmail skickas till {email}.",
  "surveyBlixtTitle": "Bli en Blixt – engagera dig digitalt för djuren!",
  "surveyBlixtBody": "Som digital volontär gör du snabba aktioner för djuren online – små uppgifter som gör verklig skillnad. Du får uppgifterna på din mejl och kan också använda vår BlixtApp som löpande fylls med aktiviteter.",
  "surveyBlixtMoreLabel": "Vad gör en digital volontär?",
  "surveyBlixtFact1": "Skriver under namninsamlingar för djuren",
  "surveyBlixtFact2": "Skickar Blixtmail till företag och beslutsfattare",
  "surveyBlixtFact3": "Delar och sprider budskap i sociala medier",
  "surveyBlixtDone": "Tack! Nu är du en Blixt.",
  "surveyBlixtOpenApp": "Öppna BlixtAppen",
  "surveyBlixtError": "Något gick fel. Försök igen.",
  "surveyChannelEmail": "e-post",
  "surveyQuestionBadge": "Fråga {n}",
  "surveyAmountChip": "{amount} kr",
  "surveyAmountGroupSwish": "Swisha en engångsgåva",
  "surveyAmountGroupMonthly": "Bli månadsgivare",
  "surveyShareDecline": "Nej tack",
  "surveyShareVia": "via",
  "surveyShareLinkLabel": "Länk att dela",
  "surveyShareCopy": "Kopiera länken",
  "surveyShareCopied": "Länken är kopierad",
  "opensInNewTab": "(öppnas i en ny flik)",
  "petitionStepMessage": "Meddelande",
  "petitionMessagePlaceholder": "Skriv ett meddelande (valfritt)",
  "petitionMessageLabel": "Ditt meddelande",
  "petitionNewsletterOptIn": "Ja tack, jag vill ha nyhetsbrev",
  "petitionSubmit": "Skriv under",
  "petitionThankYouTitle": "Tack för din underskrift!",
  "petitionThankYouBody": "Din underskrift har registrerats.",
  "petitionAlreadySigned": "Du har redan skrivit under.",
  "petitionErrorMessage": "Något gick fel. Försök igen.",
  "loading": "Laddar",
  "secondAskSigningAs": "Du skriver under som",
  "secondAskPetitionTitle": "Skriv under namninsamlingen",
  "petitionMotivationLabel": "Berätta varför du skriver under (frivilligt, visas här på sidan)",
  "petitionBlixtmailOptIn": "Ja, jag vill få Blixtmail en gång i veckan med tips på aktiviteter att göra för djuren.",
  "petitionProgressLabel": "{count} underskrifter – nu satsar vi på {goal}!",
  "secondAskAlreadySigned": "Du har redan skrivit under",
  "secondAskDonateWithSwish": "Swisha {amount} {currency}",
  "secondAskDonateWithCard": "Betala {amount} {currency} med kort",
  "secondAskSwishTo": "Swish-förfrågan går till {mobile}.",
  "secondAskSwishChange": "Byt nummer",
  "secondAskSwishWrongNumber": "Fel nummer? Ändra",
  "secondAskPaymentCancelled": "Betalningen avbröts. Försök igen, eller ändra numret om det var fel.",
  "secondAskBecomeMonthly": "Bli månadsgivare {amount} kr/mån",
  "secondAskRaiseTo": "Höj till {amount} kr/mån",
  "secondAskCurrentMonthly": "Du ger {amount} kr/mån i dag",
  "secondAskDonorAs": "Du ger som",
  "secondAskMembershipSuccess": "Välkommen som månadsgivare!",
  "secondAskRaiseSuccess": "Ditt månadsbelopp är uppdaterat",
  "secondAskDonationTitle": "Stöd djuren med en gåva",
  "secondAskMonthlyTitle": "Bli månadsgivare",
  "shopBuyNow": "Köp nu",
  "shopSoldOut": "Slutsåld",
  "shopViewInStore": "Visa i butiken",
  "shopVariant": "Variant",
  "shopNoProducts": "Inga produkter att visa just nu.",
  "shopMemberPrice": "Medlemspris",
  "bankidQrEnlargedTitle": "Skanna QR-koden",
  "bankidQrEnlargedLabel": "Förstorad QR-kod för BankID",
  "bankidQrEnlargedHint": "Öppna BankID-appen på din telefon och skanna koden.",
  "bankidQrAlt": "QR-kod att skanna med BankID-appen",
  "bankidEnlargeQr": "Förstora QR-koden",
  "bankidExtend": "Förläng tiden",
  "bankidExpired": "Tiden är slut",
  "close": "Stäng",
  "actStepStart": "Start",
  "actStepAmount": "Gåva",
  "actStepDetails": "Personuppgifter",
  "actStepAddress": "Adressuppgifter",
  "actStepPayment": "Betalsätt",
  "actAmountTitle": "Hur mycket vill du ge till arbetet för djuren?",
  "actDetailsTitle": "Vem är du?",
  "actDetailsSubtitle": "Fyll i dina uppgifter",
  "actAddressTitle": "Var bor du?",
  "actAddressSubtitle": "Hämtade uppgifter",
  "actAddressSubtitleManual": "Fyll i dina uppgifter",
  "actPaymentTitle": "Hur vill du betala din gåva till djuren?",
  "actPaymentSubtitle": "Välj hur du vill betala",
  "actPaymentTitleSingle": "Fortsätt till betalningen",
  "actPaymentSubtitleSingle": "Fortsätt till betalningen",
  "actAmountEyebrow": "Min gåva till djuren",
  "actAmountEyebrowCompany": "Vår gåva till djuren",
  "actAmountHint": "Välj en summa att bidra med",
  "actAmountOther": "Valfritt",
  "actAmountCustomLabel": "Välj hur mycket du vill ge",
  "actAmountCustomLabelCompany": "Välj hur mycket ni vill ge",
  "actSingle": "Engångsgåva",
  "actMonthly": "Månadsgåva",
  "actSsnPlaceholder": "ÅÅÅÅMMDD-NNNN",
  "actSsnHint": "Till exempel 19940906-2388, används för att registrera din gåva och försöka hämta din postadress.",
  "actNoSsn": "Jag har inget svenskt personnummer",
  "actHasSsn": "Jag har ett svenskt personnummer",
  "actBirthDateHint": "Ett födelsedatum, ÅÅÅÅ-MM-DD",
  "actMobileHint": "Fyll i ditt mobilnummer utan bindestreck eller mellanslag, t.ex. +46xxxxxxxxx",
  "actFillOther": "Fyll i andra uppgifter",
  "actLookupName": "Namn",
  "actLookupChangeAddress": "Fyll i andra uppgifter",
  "actLookupUseFetched": "Använd hämtade uppgifter",
  "actLookupBannerPending": "Hämtar dina uppgifter …",
  "actLookupBannerFound": "Dina uppgifter hämtades!",
  "actLookupBannerFailed": "Kunde inte slå upp adressuppgifter!",
  "actPaySwish": "Swish",
  "actPaySwishDesc": "Smidigt och enkelt, vi rekommenderar!",
  "actPayCard": "Kort",
  "actPayCardDesc": "Dras direkt från ditt betalkort",
  "actPayCardDescCompany": "Dras direkt från ert betalkort",
  "actPayPostal": "Inbetalningskort",
  "actPayPostalDesc": "Få hem ett inbetalningskort med posten",
  "actPayBySwish": "Betala med Swish",
  "actPayByCard": "Betala med kort",
  "actPayByPostal": "Betala",
  "actReadMore": "Läs mer",
  "videoPlay": "Spela upp videon",
  "videoPause": "Pausa videon",
  "completing": "Ett ögonblick …",
  "actConsentTitle": "Signera ditt medgivande för autogiro",
  "actConsentSubtitle": "Välj hur du vill signera",
  "actConsentBankid": "BankID",
  "actConsentBankidDesc": "Signera smidigt direkt med BankID",
  "actConsentPostal": "Pappersblankett",
  "actConsentPostalDesc": "Få hem en blankett på posten",
  "actBankTitle": "Hämta bankkonto",
  "actBankTitleManual": "Fyll i dina bankuppgifter",
  "actBankTitleFetched": "Dina hämtade bankuppgifter",
  "actBankSubtitle": "Autogiro funkar bara med vissa konton, så dubbelkolla gärna i banken att ditt konto stödjer autogiro",
  "actSignTitle": "Skriv under med BankID",
  "actSignSubtitle": "Genom att skriva under godkänner jag dessa villkor",
  "actConsentOtherMethod": "Välj ett annat sätt att signera",
  "actMonthlyStepAmount": "Summa",
  "actMonthlyStepAddress": "Adress",
  "actPerMonthSuffix": "/månad",
  "actStepBank": "Bank",
  "actStepSign": "Skriv under"
}
